// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line-bottom-1px[data-v-f02743d2] {\n  margin-top: 40px;\n  border-bottom: 1px solid #D3D7DF;\n}", ""]);
// Exports
module.exports = exports;
